/** Shared select/multi-select search matching (normalize spaces & punctuation). */
export function matchesSelectSearch(
  label: unknown,
  value: unknown,
  query: string,
  keywords?: unknown
): boolean {
  const raw = String(query || "")
    .trim()
    .toLowerCase();
  if (!raw) return true;

  const normalize = (s: unknown) =>
    String(s ?? "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/gi, " ")
      .replace(/\s+/g, " ")
      .trim();

  const hay = `${normalize(label)} ${normalize(value)} ${normalize(
    keywords
  )}`.trim();
  const qNorm = normalize(raw);
  if (!qNorm) return true;

  // Every typed token must appear (e.g. "2 bhk" → "2BHK 1200 sqft")
  return qNorm.split(" ").every((token) => token && hay.includes(token));
}
